import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTypePipe } from './action-type.pipe';



@NgModule({
    declarations: [
        ActionTypePipe
    ],
    exports: [
        ActionTypePipe
    ],
    imports: [
        CommonModule
    ]
})
export class ActionTypeModule { }
